module.exports = __webpack_public_path__ + "/bundle/asset/admission3-1-65ecdefa08f1e4bdcb8905537abcca2f.png";